import { GetCustomerCopyFunc } from '@lyrahealth-inc/shared-app-logic'

export const walmartisrael: GetCustomerCopyFunc = () => {
  return {
    hideWorkLifeServicesForInternationalUser: true,
  }
}
